import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import mutations from './mutations.js';
import actions from './actions.js';
import nativeStore from "@/store/nativeStore";
import createNativeCallback from '@/plugins/nativeCallback'

Vue.use(Vuex);

//Mber store state
const state = {
  xRefToken : '', //리프레시 토큰
  xScmToken : '', //통신 토큰
  device: '',  // web: pc, mob: mobile web, and: android app, ios, ios app
  deviceId: "SVCAPP",  //디바이스 분류
  partnerId: "C0000016",  //고객사 코드
  pgCode: "toss_payments_1", // PG코드
  autoReloadPgCode: "brandpay", // 자동충전PG코드
  autoReloadClientKey: process.env.VUE_APP_API_TOSS_CLIENT_KEY, // 자동충전PG코드
  langTyCode : "ko-KR",
  menuTitle: '',  //메뉴 제목
  bridge: null, //브릿지 페이지
  certCallback: Function,
  loadingV2: 0,     // [23.09.21] true/false 로 할 경우 비동기 호출 시 로딩이 풀리는 현상이 있어 int 값으로 변경
  loadUse: true,    // 로딩 사용
  isRefreshing: false,  //새로고침중 여부
  prepaidCardNo: '', // 선불카드 정보(상세페이지용)
  mberInfo: {
    mberNo : '',      // 회원 고유번호
    ctmmnyNo : 'C0000016',   //고객사 번호
    custBusiNm : '',   // 이름
    cino : '',         // 고객연계번호
    custStatCd : '',   // 회원상태코드(정상, 정지, 휴면, 탈회등)
    cust1Email : '',   // 이메일1
    cust2Email : '',   // 이메일2
    foreigner : '',    // 외국인여부
    mobile1TelNo : '', // 휴대전화1
    mobile2TelNo : '', // 휴대전화2
    mobile3TelNo : '',  // 휴대전화3
    billKey : '',       // 간편충전시 사용할 빌키
    prepaidCardList : [],  //선불카드 리스트
  },
  goodInfo: {},
  orderType: '',
  loginModal: false,
  loginPath: '',
  orderResultBack: false, // 홈 -> 구매/선물완료 뒤로가기 시 이마트앱 이동(이마트앱에서 뒤로가기 활성화)
  cert: Object, // 본인인증 정보
  certFnType: '', //TODO 임시
  isMberPwdAuthenticated: false,  // 이마티콘 회원 비밀번호 인증 여부
  autoReloadData: {}, // 자동충전 설정 정보 - 퀵계좌이체 등록 후 데이터 보존
  autoReloadCardInfo: {}, // 자동충전 선불카드 정보 - 퀵계좌이체 등록 후 데이터 보존
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters: {
    // [23.09.21] 로딩 On/Off 판단하는 함수 신규 추가
    getIsLoadingOn(state) {
      return state.loadUse && (state.loadingV2 > 0);
    }
  },
  modules: {
    nativeStore: nativeStore,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: ['mberInfo.mberNo', 'prepaidCardNo', 'goodsInfo', 'orderType', 'isMberPwdAuthPass', 'isMberPwdAuthenticated', 'nativeStore', 'autoReloadData', 'autoReloadCardInfo'],
    }),
    createNativeCallback(),
  ]
})

export default store;
